import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import CONFIG from 'src/app/app.config';
import { UserdataService } from 'src/app/services/user/userdata.service';

declare var SqPaymentForm: any;
@Component({
  selector: 'app-pconfirm',
  templateUrl: './pconfirm.component.html',
  styleUrls: ['./pconfirm.component.scss']
})
export class PConfirmComponent implements OnInit {
  packages: any[] = CONFIG.APPLICATION.PACKAGES;
  isActive = false;
  contact_url = CONFIG.APPLICATION.ADDITIONAL.CONTACT_US;
  paymentPath = CONFIG.APPLICATION.PATHS.PAYMENT;
  items = CONFIG.APPLICATION.FEATURES;
  paymentModalRef: any;

  constructor(private userDataService: UserdataService,
    private router: Router) {}

  ngOnInit(): void {
  }

  openFeedback() {
    (window as any)['appzi'].openWidget(CONFIG.APPLICATION.FEEDBACK.WIDGET_ID);
  }

  purchase(pricePackage: any) {
    if(pricePackage.name == "Institution") {
      window.open(this.contact_url, "_blank");
      return;
    }
    this.router.navigate([this.paymentPath], {queryParams: {p: pricePackage.name}});
  }
}
